import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../stores';

/**
 * Layout wrapper for guest-only routes (login, register).
 * Redirects authenticated users to the home page.
 */
export function GuestLayout() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
